import React from 'react'
import {Button} from './Button'
import {ArrowRight, CalendarIcon} from './icons'
import {demoBookingUrl, signupPageHref} from './constants'

function FinalCtaV2() {
  return (
    <section className="hlm-final">
      <div className="hlm-final-band">
        <h2>Ready to take control of your listings?</h2>
        <p>Set up your first listing in just a few minutes.</p>
        <div className="hlm-final-ctas">
          <Button href={signupPageHref} variant="sky" size="lg">
            Start free
            <ArrowRight size={18} stroke={2} />
          </Button>
          <Button href={demoBookingUrl} variant="ghost-dark" size="lg" target="_blank" rel="noopener noreferrer">
            Book a demo
            <CalendarIcon size={18} />
          </Button>
        </div>
        <div className="hlm-final-captions">
          <span>14-day free Pro trial · No credit card required</span>
          <span>Then subscribe to Pro for $39/mo, or stay on Basic free forever</span>
        </div>
      </div>
    </section>
  )
}

export default FinalCtaV2
